import Vue from 'vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from '../gsap-bonus/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

Vue.component('product-header-buttons', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            scrollTriggerHero: null,
            heroBlock: null,
            buttonsBlock: null,

        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.heroBlock = this.$el.parentNode.parentNode;
        this.buttonsBlock = this.$el;

        // console.log(this.heroBlock);

        this.scrollTriggerHero = gsap.timeline({
            scrollTrigger: {
                trigger: this.heroBlock,
                start: 'top',
                end: '+=80',
                scrub: true,
            },
        });

        this.scrollTriggerHero
            .to(this.buttonsBlock, {
                duration: 1,
                autoAlpha: 0,
                ease: 'power1.out',
            });
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {},
});
